// extracted by mini-css-extract-plugin
export default {"control":"Product_control__B55RA","richText":"Product_richText__u19Ai"};